import { Action } from "redux";

export const GET_TAGS_FOR_ORGANIZATION = "GET_TAGS_FOR_ORGANIZATION";

export interface GetTagsForOrganizationAction extends Action {
  type: typeof GET_TAGS_FOR_ORGANIZATION;
  organization: string;
}

export const getTagsForOrganization = (
  organizationKeyName: string
): GetTagsForOrganizationAction => ({
  type: GET_TAGS_FOR_ORGANIZATION,
  organization: organizationKeyName,
});
